import { logger } from '@lusha/client-logger';
import { flow, getRoot } from 'mobx-state-tree';
import { fetchUserCalendarSettings } from '../../../API/PluginCalendarAPI';
import { fetchActiveUserIntegration } from '../../../API/userIntegrationsAPI';
const Actions = self => ({
    fetchCalendarSettings: flow(function* fetchCalendarSettings() {
        const { user: { id }, } = getRoot(self);
        try {
            self.isLoaded = false;
            const integrations = yield fetchActiveUserIntegration();
            self.integrationId = (integrations === null || integrations === void 0 ? void 0 : integrations.integrationId) || 0;
            const calendarSettings = yield fetchUserCalendarSettings(id);
            self.isCalendarEnabled = (calendarSettings === null || calendarSettings === void 0 ? void 0 : calendarSettings.isCalendarEnabled) || false;
            self.isExtensionPermissionEnabled = Boolean(calendarSettings === null || calendarSettings === void 0 ? void 0 : calendarSettings.isExtensionPermissionEnabled);
            self.isLoaded = true;
        }
        catch (e) {
            self.isLoaded = true;
            logger.info(`Failed to fetch calendar setting and integration details for userId ${id}`);
        }
    }),
});
export default Actions;
